import { type InternalTreeMapNode } from '../types/internal.js';

export const getFilteredNodes = (
  nodes: InternalTreeMapNode[],
  selectedIds: string[],
) => {
  if (!selectedIds.length) {
    return nodes;
  }
  return nodes.filter((node) => selectedIds.includes(node.name));
};
